<template>
  <div class="paper_page" v-loading="paperLoading" element-loading-text="加载中，请稍候···" element-loading-custom-class="loading_color" element-loading-spinner="el-icon-loading">
    <header class="paper_page_header">
      <img src="@/assets/images/header/logo.png" alt />
      <div class="paper_name">{{ paper.pname }}</div>
    </header>
    <section class="paper_container">
      <div class="aside" v-if="questionStatus.length">
        <questionCard
          @clearTimer="clearTimer"
          @starTime="starTime"
          :objectiveScore="objective_score"
          :otherOffsetAngle="otherOffsetAngle"
          :major-quesiton-score="major_quesiton_score"
          :pieChartData="pieChartData"
          :full-score="paper.fullScore"
          :all-time="answer_time"
          :cost-time="cost_time"
          :question-status="questionStatus"
          :question-submit-info="questionSubmitInfo"
          :subject-id="paper.subjectId"
          :new-question-status="newqs"
          :appid="app_id"
        ></questionCard>
      </div>
      <div class="main">
        <div v-if="paperLoading == false" class="paper">
          <!-- 遍历顺序 : 1.子卷 2.大题 3.题-->
          <div v-if="paper.gkPapers != null">
            <div v-for="(childPaper, index) in paper.gkPapers" :key="index">
              <!-- 音频抽屉组件 -->
              <div
                v-if="
                  paper.listenResource != null &&
                  paper.listenResource.path != null &&
                  paper.listenResource.path &&
                  isShowPaperName(childPaper) &&
                  isShowAudio(childPaper) &&
                  playShow
                "
                :class="['drawer', { active: isActive, close: isClose }]"
              >
                <vue-audio :url="`${ backURL }/apis/upload/${paper.listenResource.path}`" :duration="paper.listenResource.duration"></vue-audio>
                <div class="text" v-if="!isActive" @click="clickBtn">
                  <i class="el-icon-right"></i>
                  <br>
                  听力材料
                </div>
                <div class="text" v-else @click="closeDrop">
                  <i class="el-icon-back"></i>
                  <br>
                  收起
                </div>
              </div>
              <!-- 如果大题不为空则遍历大题 -->
              <div class="desc-info" v-show="isShowPaperName(childPaper)">{{childPaper.pname}} {{ childPaper.description }}</div>
              <div v-if="childPaper.gkBigQuestions != null">
                <div
                  class="concrete_question"
                  v-for="(bigQuestion, index) in childPaper.gkBigQuestions"
                  :key="index"
                >
                  <div class="desc-info-bottom" v-show="isShowBigQuestionName(bigQuestion)">{{ bigQuestion.name }} {{ bigQuestion.description }}</div>
                  <div v-for="(question, index) in bigQuestion.gkQuestions" :key="index">
                    <template v-if="question.typeCode == 'M'">
                      <compositeQuestion
                        :subject-id="paper.subjectId"
                        v-show="isShowQuestion(question)"
                        :question="question"
                        :is-show-answer-area="false"
                      ></compositeQuestion>
                    </template>
                    <template v-else>
                      <baseQuestion
                        v-show="question.original == question_tab"
                        :question="question"
                        :q-tab="+question_tab"
                        :is-show-answer-area="false"
                      ></baseQuestion>
                    </template>
                  </div>
                </div>
              </div>
              <div v-if="childPaper.gkQuestions != null && childPaper.gkQuestions">
                <div class="concrete_question" v-for="(question, index) in childPaper.gkQuestions" :key="index">
                  <template v-if="question.typeCode == 'M'">
                    <compositeQuestion
                      v-show="isShowQuestion(question)"
                      :question="question"
                      :subject-id="paper.subjectId"
                      :is-show-answer-area="false"
                    ></compositeQuestion>
                  </template>
                  <template v-else>
                    <baseQuestion
                      v-show="question.original == question_tab"
                      :question="question"
                      :q-tab="+question_tab"
                      :is-show-answer-area="false"
                    ></baseQuestion>
                  </template>
                </div>
              </div>
              </div>
            </div>
          <!-- 如果大题不为空则遍历大题 -->
          <div v-if="paper.gkBigQuestions != null">
            <div v-for="(bigQuestion, index) in paper.gkBigQuestions" :key="index">
              <div class="desc-info-bottom" v-show="isShowBigQuestionName(bigQuestion)">{{ bigQuestion.name }} {{ bigQuestion.description }}</div>
              <div v-for="(question, index) in bigQuestion.gkQuestions" :key="index">
                <template v-if="question.typeCode == 'M'">
                  <compositeQuestion
                    v-show="isShowQuestion(question)"
                    :question="question"
                    :is-show-answer-area="false"
                  ></compositeQuestion>
                </template>
                <template>
                  <base-question
                    v-show="question.original == question_tab"
                    :question="question"
                    :is-show-answer-area="false"
                  ></base-question>
                </template>
              </div>
            </div>
          </div>
          <!-- 如果题不为空则遍历题 -->
          <div v-if="paper.gkQuestions != null">
            <div v-for="(question, index) in paper.gkQuestions" :key="index">
              <div v-if="question.typeCode == 'M'">
                <compositeQuestion
                  v-show="isShowQuestion(question)"
                  :question="question"
                  :is-show-answer-area="false"
                ></compositeQuestion>
              </div>
              <div v-else>
                <baseQuestion
                  v-show="question.original == question_tab"
                  :question="question"
                  :q-tab="+question_tab"
                  :is-show-answer-area="false"
                ></baseQuestion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import vueAudio from "@/components/audio/index"
import questionCard from "@/components/paper/card/paper_preview_card";
import compositeQuestion from "@/components/paper/question/question/composite_question";
import bigQuestion from "@/components/paper/question/question/big_question";
import childPaper from "@/components/paper/child_paper/child_paper";
import pieChart from "@/components/ali-g2-charts/pie-chart";
import baseQuestion from "@/components/paper/question/question/base_question";
export default {
  name: "paper",
  components: {
    questionCard,
    bigQuestion,
    childPaper,
    compositeQuestion,
    pieChart,
    baseQuestion,
    pdf,
    vueAudio
  },
  data() {
    return {
      audio: null,
      playShow: true,
      paperDialogVisible: false, // 试卷预览添加
      paperSeeVisible: false,
      backURL : this.$config.backURL,
      //记时使用
      answer_time: 0, //考试时间
      question_num: 0,
      count_down: "00:00:00", //记时显示用
      out_time: "00:00:00", //超时时间
      cost_time: 0,
      question_tab: 1,
      //试卷信息
      paper: {},
      //问题id数组
      qnArray: [],
      questionStatus: [], //题的状态
      //提交的试卷信息
      questionSubmitInfo: {},
      test_id: 0,
      answer_count: 0,
      //试卷的类型
      app_id: 0,
      app_name: "",
      //等待
      paperLoading: false,
      tab: "home",
      fontSize: 20,
      options: [
        {
          value: 18,
          label: "小",
        },
        {
          value: 20,
          label: "标准",
        },
        {
          value: 22,
          label: "大",
        },
        {
          value: 24,
          label: "较大",
        },
        {
          value: 26,
          label: "超大",
        },
      ],
      dialogSubmitVisible: true,
      count_down_timer: null,
      timers: null,
      dialogLoading: true,
      pieChartData: [],
      pieOtherData: [],
      otherOffsetAngle: 0,
      major_quesiton_score: 0,
      objective_score: 0,
      // 音频抽屉
      isActive: false,
      isClose: false,
      //pdf
      pageCount: 0,
      pdfUrl: "",
      numPages: 0,
      newqs: {}, // 为实现复合题选项卡添加
      newqsIndex: -1,
    };
  },
  computed: {
    isShowAudio () {
      return function (childPaper) {
        return childPaper.pname.indexOf('听力') != -1
      }
    },
    isShowQuestion(){
      return function (qusetion) {
        let isShow = false;
        if (qusetion.subQuestions != undefined) {
          qusetion.subQuestions.forEach((element) => {
            if (element.original == this.question_tab) isShow = true;
          });
        }
        return isShow;
      };
    },
    isShowPaperName(){
      return function (childPaper) {
        let isShow = false;
        if(childPaper.gkBigQuestions != null && childPaper.gkBigQuestions.length != 0){
            let array = childPaper.gkBigQuestions;

            for (let index = 0; index < array.length; index++) {
              const element = array[index];

              for (let j = 0; j < element.gkQuestions.length; j++) {
                const firstQuestion = element.gkQuestions[j];
                if(firstQuestion.typeCode == 'M'){
                  if (firstQuestion.subQuestions != null && firstQuestion.subQuestions != undefined && firstQuestion.subQuestions.length) {
                    let arraySubs = firstQuestion.subQuestions;
                    for (let z = 0; z < arraySubs.length; z++) {
                      const zelement = arraySubs[z];
                      if(zelement.original == this.question_tab){
                        isShow = true;
                      }
                    }
                  }
                }else{
                  if(firstQuestion.original == this.question_tab){
                    isShow = true;
                  }
                }
              }
              
            }

            let firstBigQuestion = array[0];
            let firstQuestion = firstBigQuestion.gkQuestions[0];
              if(firstQuestion.typeCode == 'M'){
                if (firstQuestion.subQuestions != null && firstQuestion.subQuestions != undefined && firstQuestion.subQuestions.length) {
                  let arraySubs = firstQuestion.subQuestions;
                  if(arraySubs[0].original == this.question_tab){
                    isShow = true;
                  }
                }
              }else{
                if(firstQuestion.original == this.question_tab){
                  isShow = true;
                }
              }
            
        }

        if(childPaper.gkQuestions && childPaper.gkQuestions.length != 0){
          for (let j = 0; j < childPaper.gkQuestions.length; j++) {
            const firstQuestion = childPaper.gkQuestions[j];
            if(firstQuestion.typeCode == 'M'){
              if (firstQuestion.subQuestions != null && firstQuestion.subQuestions != undefined && firstQuestion.subQuestions.length) {
                let arraySubs = firstQuestion.subQuestions;
                for (let z = 0; z < arraySubs.length; z++) {
                  const zelement = arraySubs[z];
                  if(zelement.original == this.question_tab){
                    isShow = true;
                  }
                }
              }
            }else{
              if(firstQuestion.original == this.question_tab){
                isShow = true;
              }
            }
          }
        }
        // console.log("isShow : " , isShow);
        return isShow;
      };
    },
    isShowBigQuestionName(){
      return function(bigQuestions){
        let isShow = false;
        for (let index = 0; index < bigQuestions.gkQuestions.length; index++) {
          const question = bigQuestions.gkQuestions[index];
          if(question.typeCode == 'M'){
            if (question.subQuestions != null && question.subQuestions != undefined && question.subQuestions.length) {
              for (let i = 0; i < question.subQuestions.length; i++) {
                if(question.subQuestions[i].original == this.question_tab){
                  isShow = true;
                }
              }
            }
          }else{
            if(question.original == this.question_tab){
              isShow = true;
            }
          }
        }
        return isShow;
      }

    },
  },
  methods: {
    toHome(val) {
      this.$confirm('此操作将退出答题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (val === 1) {
          this.$router.push({
            path: '/tfedu_common/home'
          })
        } else {
          this.$router.push({
            path: '/tfedu_common/expert',
            query: {
              id: this.paper.subjectId
            }
          })
        }
      })
    },
    openpdf() {
      window.open(
        this.$config.backURL + "/apis/upload/gk-resource/preview-pdf/"+this.paper.id+".pdf"      );
    },
    openPreView() {
      this.$router.push({
        path: '/preview',
        query: {
          'paper_id': this.$route.query.paper_id,
          'question_tab': this.question_tab
        }
      })
    },
    // 音频展示
    clickBtn() {
      this.isActive = true;
      this.isClose = false;
    },
    closeDrop() {
      this.isClose = true;
      this.isActive = false;
    },
    clearTimer() {
      clearInterval(this.count_down_timer);
    },
    starTime() {
      this.interval(this.cost_time);
    },
    selectFontSize(val) {
      this.$root.eventHub.$emit("fontsize", val);
    },
    closeDialog() {
      this.dialogSubmitVisible = false;
    },
    interval(last_time) {
      /*  计时器
				东八区00：00：00为记时开始时间
			*/
      //1.获得开始时间 开始的毫秒数
      let lastTime = last_time ? last_time : 0;
      let start_millisecond = -8 * 60 * 60 * 1000 + lastTime;
      let start_time = new Date(start_millisecond);
      //2.获得结束时间 结束的毫秒数
      let end_millisecond = start_millisecond + this.answer_time * 60 * 1000;
      this.count_down = start_time.toTimeString().split(" ")[0];
      //超时时间起始时间
      let out_millisecond = -8 * 60 * 60 * 1000;
      this.count_down_timer = setInterval(() => {
        if (start_millisecond <= end_millisecond) {
          start_millisecond = start_millisecond + 1000;
          // this.timers = start_millisecond + 8 * 60 * 60 * 1000;
          // this.cost_time = (start_millisecond + 8 * 60 * 60 * 1000) / 1000 / 60;
          this.cost_time += 1000;
          this.count_down = new Date(start_millisecond)
            .toTimeString()
            .split(" ")[0];
        } else {
          this.out_time = new Date(out_millisecond)
            .toTimeString()
            .split(" ")[0];
          out_millisecond = out_millisecond + 1000;
        }
      }, 1000);
    },
    //初始化试卷
    async initPage() {
      this.paperLoading = true;
      let id = this.$route.query.paper_id;
      await this.$HTTP
        .executeGet(this.$APIS.GET_PAPER_BY_ID + id, this)
        .then((res) => {
          if (res.msg == "Success!") {
            //获得整个试卷的信息
            let gkpaper = res.data;
            this.paper = gkpaper;
            let subjectId = gkpaper.subjectId;
            this.$nextTick(() => {
              this.audio = this.$refs[`play-${this.paper.id}`];
              if (this.audio) {
                this.audio.addEventListener(
                  "ended",
                  () => {
                    this.playShow = false;
                  },
                  false
                );
              }
            });
            // this.$delete(this.paper,'gkQuestions');
            if (gkpaper.fullScore == undefined) {
              gkpaper.fullScore = 0;
            }

            this.getTestId(gkpaper);
            //获得试卷的考试时间
            this.answer_time = res.data.duration;
            //获得所有的题号id
            let qc = 0;
            let order = 1;
            let qs = [];

            let major_question_count = 0;
            let major_quesiton_score = 0;

            let radio_question_number = 0;
            let multi_question_number = 0;
            let judge_question_number = 0;
            let radio_question_score = 0;
            let multi_question_score = 0;
            let judge_question_score = 0;
            if (gkpaper.gkPapers != undefined) {
              gkpaper.gkPapers.forEach((gp) => {
                if (gp.gkBigQuestions != undefined) {
                  gp.gkBigQuestions.forEach((gbq) => {
                    if (gbq.gkQuestions != undefined) {
                      gbq.gkQuestions.forEach((gq) => {
                        gq.status = false;

                        if (gq.typeCode == "M") {
                          if (gq.subQuestions != undefined && gq.subQuestions != null && gq.subQuestions.length) {
                            qc += gq.subQuestions.length;

                            gq.subQuestions.forEach((sq) => {
                              sq.status = false;
                              sq.questionOrder = order++;
                              let major_question = ["E", "S"];
                              if (
                                major_question.indexOf(sq.typeCode) == -1
                                  ? true
                                  : false
                              ) {
                                major_question_count++;
                                major_quesiton_score += sq.score;
                              }
                              if (sq.typeCode == "A") {
                                radio_question_number++;
                                radio_question_score += sq.score;
                              }
                              if (sq.typeCode == "B") {
                                multi_question_number++;
                                multi_question_score += sq.score;
                              }
                              if (sq.typeCode == "C") {
                                judge_question_number++;
                                multi_question_score += sq.score;
                              }
                              qs.push({
                                parent_id: gq.original,
                                parent_typeId: gq.typeId,
                                card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                                order: sq.original,
                                status: false,
                                correct: false,
                                score: 0, //得分
                                type_code: sq.typeCode,
                                question_score: sq.score, //题的分数
                                self_answer: undefined,
                                answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                                id: sq.id,
                                audit_status: true,
                                originalName: sq.originalName.trim(),
                                answerUnicity : sq.answerUnicity,
                                type_id : sq.typeId
                                // major_question.indexOf(sq.typeCode) == -1
                                //   ? true
                                //   : false, //批改状态
                              });

                              if (!this.newqs.hasOwnProperty(gq.originalName)) {
                                this.$set(this.newqs, gq.originalName, [])
                                this.newqs[gq.originalName].push({
                                  index: ++this.newqsIndex,
                                  name: sq.originalName.trim(),
                                  status: false,
                                  id: sq.id,
                                  type_id : sq.typeId,
                                  original: sq.original
                                })
                              } else {
                                this.newqs[gq.originalName].push({
                                  index: ++this.newqsIndex,
                                  name: sq.originalName.trim(),
                                  status: false,
                                  id: sq.id,
                                  type_id : sq.typeId,
                                  original: sq.original
                                })
                              }
                            });
                          }
                        } else {
                          gq.questionOrder = order++;
                          qc++;
                          let major_question = ["E", "S"];
                          if (
                            major_question.indexOf(gq.typeCode) == -1
                              ? true
                              : false
                          ) {
                            major_question_count++;
                            major_quesiton_score += gq.score;
                          }
                          if (gq.typeCode == "A") {
                            radio_question_number++;
                            radio_question_score += gq.score;
                          }
                          if (gq.typeCode == "B") {
                            multi_question_number++;
                            multi_question_score += gq.score;
                          }
                          if (gq.typeCode == "C") {
                            judge_question_number++;
                            multi_question_score += gq.score;
                          }
                          qs.push({
                            parent_id: gq.original,
                            parent_typeId: gq.typeId,
                            card_originalName : gq.originalName,
                            order: gq.original,
                            status: false,
                            correct: false,
                            score: 0,
                            type_code: gq.typeCode,
                            question_score: gq.score,
                            self_answer: undefined,
                            answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                            id: gq.id,
                            audit_status: true,
                            originalName : gq.originalName.trim(),
                            answerUnicity : gq.answerUnicity,
                            type_id : gq.typeId
                            // major_question.indexOf(gq.typeCode) == -1
                            //   ? true
                            //   : false, //批改状态
                          });

                          if (!this.newqs.hasOwnProperty(gq.originalName)) {
                            this.$set(this.newqs, gq.originalName, [])
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: gq.originalName.trim(),
                              status: false,
                              id: gq.id,
                              type_id : gq.typeId,
                              original: gq.original
                            })
                          } else {
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: gq.originalName.trim(),
                              status: false,
                              id: gq.id,
                              type_id : gq.typeId,
                              original: gq.original
                            })
                          }
                        }
                      });
                    }
                  });
                }
                if (gp.gkQuestions != undefined) {
                  gp.gkQuestions.forEach((gq) => {
                    gq.status = false;

                    if (gq.typeCode == "M") {
                      if(gq.subQuestions != null && gq.subQuestions != undefined && gq.subQuestions.length) {
                        qc += gq.subQuestions.length;
                        gq.subQuestions.forEach((sq) => {
                          sq.status = false;
                          sq.questionOrder = order++;
                          let major_question = ["E", "S"];
                          if (
                            major_question.indexOf(sq.typeCode) == -1
                              ? true
                              : false
                          ) {
                            major_question_count++;
                            major_quesiton_score += sq.score;
                          }
                          if (sq.typeCode == "A") {
                            radio_question_number++;
                            radio_question_score += sq.score;
                          }
                          if (sq.typeCode == "B") {
                            multi_question_number++;
                            multi_question_score += sq.score;
                          }
                          if (sq.typeCode == "C") {
                            judge_question_number++;
                            multi_question_score += sq.score;
                          }
                          qs.push({
                            parent_id: gq.original,
                            parent_typeId: gq.typeId,
                            card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                            order: sq.original,
                            status: false,
                            correct: false,
                            score: 0,
                            type_code: sq.typeCode,
                            question_score: sq.score,
                            self_answer: undefined,
                            answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                            id: sq.id,
                            audit_status: true,
                            originalName : sq.originalName.trim(),
                            answerUnicity : sq.answerUnicity,
                            type_id : sq.typeId
                            // major_question.indexOf(sq.typeCode) == -1
                            //   ? true
                            //   : false, //批改状态
                          });
                          if (!this.newqs.hasOwnProperty(gq.originalName)) {
                            this.$set(this.newqs, gq.originalName, [])
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              type_id : sq.typeId,
                              original: sq.original
                            })
                          } else {
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              type_id : sq.typeId,
                              original: sq.original
                            })
                          }
                        });
                      }
                    } else {
                      gq.questionOrder = order++;
                      qc++;
                      let major_question = ["E", "S"];
                      if (
                        major_question.indexOf(gq.typeCode) == -1 ? true : false
                      ) {
                        major_question_count++;
                        major_quesiton_score += gq.score;
                      }
                      if (gq.typeCode == "A") {
                        radio_question_number++;
                        radio_question_score += gq.score;
                      }
                      if (gq.typeCode == "B") {
                        multi_question_number++;
                        multi_question_score += gq.score;
                      }
                      if (gq.typeCode == "C") {
                        judge_question_number++;
                        multi_question_score += gq.score;
                      }
                      qs.push({
                        parent_id: gq.original,
                        parent_typeId: gq.typeId,
                        card_originalName : gq.originalName,
                        order: gq.original,
                        status: false,
                        correct: false,
                        type_code: gq.typeCode,
                        question_score: gq.score,
                        score: 0,
                        self_answer: undefined,
                        answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                        id: gq.id,
                        audit_status: true,
                        originalName : gq.originalName.trim(),
                        answerUnicity : gq.answerUnicity,
                        type_id : gq.typeId
                        // major_question.indexOf(gq.typeCode) == -1
                        //   ? true
                        //   : false, //批改状态
                      });
                      if (!this.newqs.hasOwnProperty(gq.originalName)) {
                        this.$set(this.newqs, gq.originalName, [])
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          type_id : gq.typeId,
                          original: gq.original
                        })
                      } else {
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          type_id : gq.typeId,
                          original: gq.original
                        })
                      }
                    }
                  });
                }
              });
            }

            if (gkpaper.gkBigQuestions != undefined) {
              gkpaper.gkBigQuestions.forEach((gbq) => {
                if (gbq.gkQuestions != undefined) {
                  gbq.gkQuestions.forEach((gq) => {
                    gq.status = false;

                    if (gq.typeCode == "M") {
                      if (gq.subQuestions != null && gq.subQuestions != undefined && gq.subQuestions.length) {
                        qc += gq.subQuestions.length;
                        gq.subQuestions.forEach((sq) => {
                          sq.status = false;
                          sq.questionOrder = order++;
                          let major_question = ["E", "S"];
                          if (
                            major_question.indexOf(sq.typeCode) == -1
                              ? true
                              : false
                          ) {
                            major_question_count++;
                            major_quesiton_score += sq.score;
                          }
                          if (sq.typeCode == "A") {
                            radio_question_number++;
                            radio_question_score += sq.score;
                          }
                          if (sq.typeCode == "B") {
                            multi_question_number++;
                            multi_question_score += sq.score;
                          }
                          if (sq.typeCode == "C") {
                            judge_question_number++;
                            multi_question_score += sq.score;
                          }
                          qs.push({
                            parent_id: gq.original,
                            parent_typeId: gq.typeId,
                            card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                            order: sq.original,
                            status: false,
                            correct: false,
                            score: 0,
                            type_code: sq.typeCode,
                            question_score: sq.score,
                            self_answer: undefined,
                            answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                            id: sq.id,
                            audit_status: true,
                            originalName : sq.originalName.trim(),
                            answerUnicity : sq.answerUnicity,
                            type_id : sq.typeId
                            // major_question.indexOf(sq.typeCode) == -1
                            //   ? true
                            //   : false, //批改状态
                          });

                          if (!this.newqs.hasOwnProperty(gq.originalName)) {
                            this.$set(this.newqs, gq.originalName, [])
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              type_id : sq.typeId,
                              original: sq.original
                            })
                          } else {
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              type_id : sq.typeId,
                              original: sq.original
                            })
                          }
                        });
                      }
                    } else {
                      gq.questionOrder = order++;
                      qc++;
                      let major_question = ["E", "S"];
                      if (
                        major_question.indexOf(gq.typeCode) == -1 ? true : false
                      ) {
                        major_question_count++;
                        major_quesiton_score += gq.score;
                      }
                      if (gq.typeCode == "A") {
                        radio_question_number++;
                        radio_question_score += gq.score;
                      }
                      if (gq.typeCode == "B") {
                        multi_question_number++;
                        multi_question_score += gq.score;
                      }
                      if (gq.typeCode == "C") {
                        judge_question_number++;
                        multi_question_score += gq.score;
                      }
                      qs.push({
                        parent_id: gq.original,
                        parent_typeId: gq.typeId,
                        card_originalName :  gq.originalName ,
                        order: gq.original,
                        status: false,
                        correct: false,
                        type_code: gq.typeCode,
                        question_score: gq.score,
                        score: 0,
                        self_answer: undefined,
                        answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                        id: gq.id,
                        audit_status: true,
                        originalName : gq.originalName.trim(),
                        answerUnicity : gq.answerUnicity,
                        type_id : gq.typeId
                        // major_question.indexOf(gq.typeCode) == -1
                        //   ? true
                        //   : false, //批改状态
                      });

                      if (!this.newqs.hasOwnProperty(gq.originalName)) {
                        this.$set(this.newqs, gq.originalName, [])
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          type_id : gq.typeId,
                          original: gq.original
                        })
                      } else {
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          type_id : gq.typeId,
                          original: gq.original
                        })
                      }
                    }
                  });
                }
              });
            }

            if (gkpaper.gkQuestions != undefined) {
              gkpaper.gkQuestions.forEach((gq) => {
                gq.status = false;

                if (gq.typeCode == "M") {
                  if (gq.subQuestions != null && gq.subQuestions != undefined && gq.subQuestions.length) {
                    qc += gq.subQuestions.length;
                    gq.subQuestions.forEach((sq) => {
                      sq.status = false;
                      sq.questionOrder = order++;
                      let major_question = ["E", "S"];
                      if (
                        major_question.indexOf(sq.typeCode) == -1 ? true : false
                      ) {
                        major_question_count++;
                        major_quesiton_score += sq.score;
                      }
                      if (sq.typeCode == "A") {
                        radio_question_number++;
                        radio_question_score += sq.score;
                      }
                      if (sq.typeCode == "B") {
                        multi_question_number++;
                        multi_question_score += sq.score;
                      }
                      if (sq.typeCode == "C") {
                        judge_question_number++;
                        multi_question_score += sq.score;
                      }
                      qs.push({
                        parent_id: gq.original,
                        parent_typeId: gq.typeId,
                        card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                        order: sq.original,
                        status: false,
                        correct: false,
                        score: 0,
                        type_code: sq.typeCode,
                        question_score: sq.score,
                        self_answer: undefined,
                        answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                        id: sq.id,
                        audit_status: true,
                        originalName: sq.originalName.trim(),
                        answerUnicity : sq.answerUnicity,
                        type_id : sq.typeId
                        // major_question.indexOf(sq.typeCode) == -1
                        //   ? true
                        //   : false, //批改状态
                      });

                      if (!this.newqs.hasOwnProperty(gq.originalName)) {
                        this.$set(this.newqs, gq.originalName, [])
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: sq.originalName.trim(),
                          status: false,
                          id: sq.id,
                          type_id : sq.typeId,
                          original: sq.original
                        })
                      } else {
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: sq.originalName.trim(),
                          status: false,
                          id: sq.id,
                          type_id : sq.typeId,
                          original: sq.original
                        })
                      }
                    });
                  }
                } else {
                  gq.questionOrder = order++;
                  qc++;
                  let major_question = ["E", "S"];
                  if (
                    major_question.indexOf(gq.typeCode) == -1 ? true : false
                  ) {
                    major_question_count++;
                    major_quesiton_score += gq.score;
                  }
                  if (gq.typeCode == "A") {
                    radio_question_number++;
                    radio_question_score += gq.score;
                  }
                  if (gq.typeCode == "B") {
                    multi_question_number++;
                    multi_question_score += gq.score;
                  }
                  if (gq.typeCode == "C") {
                    judge_question_number++;
                    multi_question_score += gq.score;
                  }
                  qs.push({
                    parent_id: gq.original,
                    parent_typeId: gq.typeId,
                    card_originalName :  gq.originalName ,
                    order: gq.original,
                    status: false,
                    correct: false,
                    type_code: gq.typeCode,
                    question_score: gq.score,
                    score: 0,
                    self_answer: undefined,
                    answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                    id: gq.id,
                    audit_status: true,
                    originalName : gq.originalName.trim(),
                    answerUnicity : gq.answerUnicity,
                    type_id : gq.typeId
                    // major_question.indexOf(gq.typeCode) == -1
                    //   ? true
                    //   : false, //批改状态
                  });
                  // this.$set(this.obj,'e',02)

                  if (!this.newqs.hasOwnProperty(gq.originalName)) {
                    this.$set(this.newqs, gq.originalName, [])
                    this.newqs[gq.originalName].push({
                      index: ++this.newqsIndex,
                      name: gq.originalName.trim(),
                      status: false,
                      id: gq.id,
                      type_id : gq.typeId,
                      original: gq.original
                    })
                  } else {
                    this.newqs[gq.originalName].push({
                      index: ++this.newqsIndex,
                      name: gq.originalName.trim(),
                      status: false,
                      id: gq.id,
                      type_id : gq.typeId,
                      original: gq.original
                    })
                  }

                }
              });
            }
            this.question_num = qc;
            gkpaper.question_count = qc;
            this.objective_score =
              radio_question_score +
              multi_question_score +
              judge_question_score;
            this.major_quesiton_score = major_quesiton_score;
            this.full_score = gkpaper.fullScore;
            this.question_tab = qs[0].order;
            // this.question_tab = 62;

            this.questionStatus = qs;

            this.dialogLoading = false;

            console.log('this.questionStatusc==>', this.questionStatus)

            // this.loadPdfHandler(gkpaper.id)
            this.interval();
          } else {
            this.$message.error("加载试卷信息失败!");
          }
          this.paperLoading = false;
        });
    },

    getTestId(pinfo) {
      var userinfo = localStorage.getItem("userinfo");
      var user = JSON.parse(userinfo);
      let testInfo = {
        paper_id: pinfo.id, //试卷ID
        type_code: pinfo.typeId, //试卷分类：1高考真题2高考模拟3查漏补缺
        title: pinfo.pname,
        user_id: user.id,
        status: false,
        audit_status: false,
      };

      this.$HTTP
        .executePost(this.$APIS.GET_TEST_ID, testInfo, this)
        .then((res) => {
          this.test_id = res.data.id;
          window.localStorage.setItem("test_id", res.data.id);
          this.questionSubmitInfo = {
            paper_id: pinfo.id,
            test_id: this.test_id,
            user_id: user.id,
            subject_id: pinfo.subjectId,
          };
        });
    },
  },
  created() {
    if (this.$store.state.tabType == "expert") {
      this.tab = "home";
    }
    //加载试卷信息
    this.initPage();

    //获得测试appid
    let app_id = this.$route.query.app_id;
    if (app_id == 4) {
      this.app_name = "摸底考试";
    }
    if (app_id == 3) {
      this.app_name = "查漏补缺";
    }
    if (app_id == 2) {
      this.app_name = "考前冲刺";
    }
    localStorage.setItem('flagFirst', 'true')
    localStorage.setItem('flagFirst2', 'true')
  },
  mounted() {
    setTimeout(() => {
      localStorage.setItem('flagFirst2', 'false')
    }, 3000)
    // 首版隐藏
    // if (this.$store.state.tabType) {
    //     this.tab = this.$store.state.tabType
    // }
    // 首版显示
    
    // if (app_id == 100) {
    //   this.app_name = "专家测评";
    // }
    //监控答题卡传过来的question id
    this.$root.eventHub.$on("question-tab-changed", (val) => {
      this.question_tab = Number(val);
    });
    //监控答案的改动
    this.$root.eventHub.$on(
      "answer-status-changed",
      (
        type_code,
        question_score,
        status,
        original,
        ans,
        score,
        correct,
        audit_status
      ) => {
        // console.log("type_code,question_score,status,original,ans,score,correct,audit_status:",type_code,question_score,status,original,ans,score,correct,audit_status);
        //题的状态
        let qs = this.questionStatus;
        let i = 0;
        for (var j = 0; j < qs.length; j++) {
          if (qs[j].order == original) {
            i = j;
            break;
          }
        }
        qs[i].question_score = question_score;
        qs[i].status = status;
        qs[i].type_code = type_code;
        qs[i].self_answer = ans;
        qs[i].score = score;
        qs[i].correct = correct;
        qs[i].audit_status = audit_status;
     
        let count = 0;
        for (let h = 0; h < this.questionStatus.length; h++) {
          if (this.questionStatus[h].status == true) {
            count++;
          }
        }
        this.answer_count = count;
        for(let key in this.newqs){
          for (let i = 0; i < this.newqs[key].length; i++) {
            if(original == this.newqs[key][i].original) {
              this.newqs[key][i].status = status
              break
            }
          }
        }
      }
    );
  },
  beforeDestroy() {
    localStorage.setItem(`time_${this.questionSubmitInfo.paper_id}`, this.cost_time)
  },
  destroyed() {
    localStorage.setItem('flagFirst', 'false')
    localStorage.setItem('flagFirst2', 'true')

    this.$refs[`play-${this.paper.id}`].pause();
  }
};
</script>

<style lang="scss" scoped>
.paper_page {
  width: 100%;
  height: 100%;
  position: relative;
  .paper_page_header {
    width: 100%;
    color: #ffffff;
    height: 70px;
    background: #5c307d;
    position: relative;
    img {
      position: absolute;
      width: 150px;
      left: 40px;
      top: 10px;
    }
    .paper_name {
      width: 100%;
      height: 100%;
      text-align: center;
      font-size: 20px;
      line-height: 70px;
    }
  }
  .aside {
    position: absolute;
    top: 70px;
    width: 300px;
    left: 0px;
    bottom: 0px;
    border-right: 1px solid #efefef;

    ul {
      margin-top: 40px;
      li {
        line-height: 50px;
        font-size: 18px;
        padding-left: 10px;
      }
      li:hover {
        background-color: #5c307d;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .main {
    position: absolute;
    top: 70px;
    left: 300px;
    right: 0px;
    bottom: 0px;
    overflow: auto;
  }
}
.desc-info-bottom {
  font-size: 20px;
  background-color: #fff;
  line-height: 50px;
  text-align: center;
}
.desc-info {
  font-size: 20px;
  background-color: #fff;
  line-height: 50px;
  text-align: center;
}
</style>
<style lang="stylus" scoped>
.font-set {
  .el-select-dropdown__wrap {
    max-height: none;
  }

  .el-scrollbar__wrap {
    .el-select-dropdown__list {
      .el-select-dropdown__item {
        height: 50px;
        line-height: 50px;
      }

      .el-select-dropdown__item:nth-child(1) {
        font-size: 18px;
      }

      .el-select-dropdown__item:nth-child(2) {
        font-size: 20px;
      }

      .el-select-dropdown__item:nth-child(3) {
        font-size: 22px;
      }

      .el-select-dropdown__item:nth-child(4) {
        font-size: 24px;
      }

      .el-select-dropdown__item:nth-child(5) {
        font-size: 26px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/deep/ .loading_color{
  .el-icon-loading {
    color: #5c307d !important;
    font-size: 60px !important;
  }
  .el-loading-text {
    color: #5c307d !important;
    font-size: 20px !important;
  }
}
.paper-see {
  height: 800px;
  /deep/ .el-dialog__body {
    overflow: auto;
    height: 700px;
    background-color: #f5f5f5;
  }
}
</style>
<style lang="scss" scoped>
.drawer {
  position: fixed;
  // top: 350px;
  left: -340px;
  background: rgba(0, 162, 255, 0.4);
  z-index: 999;
  height: 80px;
  border-radius: 0 10px 10px 0;
  overflow: hidden;
  width: 460px;
  /deep/ .vue-audio {
    margin-top: 15px;
    margin-left: 15px;
    width: 325px;
    float: left;
    background: rgba(0, 0, 0, 0.2);
  }
  .text {
    color: #fff;
    width: 120px;
    height: 80px;
    padding: 15px 0;
    display: block;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 25px;
  }
}

.active {
  animation: opendoor 1s normal forwards;
}
@keyframes opendoor {
  0% {
    left: -340px;
  }
  100% {
    left: 0;
  }
}
// 关
.close {
  animation: close 1s normal forwards;
}
@keyframes close {
  0% {
    left: 0;
  }
  100% {
    left: -340px;
  }
}
</style>
<style lang="scss">
.el-image-viewer__wrapper {
  .el-image-viewer__close {
    color: #fff;
  }
}
</style>